/* eslint-disable import/prefer-default-export */
import request from '@/utils/request';
// 校区信息
export function fetchSchoolInfo(id) {
  return request({
    url: `/api/clients/${id}?clients_id=${id}`,
    method: 'get',
  });
}
// sdk信息
export function fetchSchoolSdk(id) {
  return request({
    url: `/api/clients-configs/detail/${id}?clients_id=${id}`,
    method: 'get',
  });
}



// WEBPACK FOOTER //
// ./src/api/school.js